<div class="document-picker-container">
  <div class="doc-breadcrumb">
    <file-breadcrumb [folderChanged]="docFolderChanged" (selectFolder)="onSelectDocFolderFromBreadcrumb($event)"></file-breadcrumb>
  </div>
  <div class="doc-file-list">
    <div class="card card-t">
      <div class="grid ma4">
        <vs-fs-list-file [(ngModel)]="docFiles" (onClick)="onDocFolderClick($event)" [isMngFile]="true" [isSingleFile]="isSingleFile" [currentIds]="docSelectedIds" (onSelectItem)="onSelectDocItem($event)" class="col-md-12">
        </vs-fs-list-file>
      </div>
    </div>
  </div>
  <div class="doc-footer">
    <button type="button" (click)="closePopup()" class="vs-btn vs-modal-btn vs-btn-action-back">
      <span class="__icon fa-light fa-times"></span>
      <span class="__label">Đóng</span>
    </button>
    <button type="button" class="vs-btn vs-modal-btn vs-btn-action-edit" (click)="onDocSelected()">
      <i class="__icon fa-light fa-check"></i> Chọn
    </button>
  </div>
</div>
